module.exports = __webpack_public_path__ + "img/eye.0dfa56e5.svg";